import peppolGateway from './peppolGateway';

class BusinessCardService {
  searchBusinessCard(query, page, size) {
    return peppolGateway.get('/json?q=' + query + '&resultPageIndex=' + page + '&resultPageCount=' + size)
  }
}

export default new BusinessCardService()
